module.exports = __webpack_public_path__ + "assets/img/pt-f2ae65f3.png";